import { Search } from '@bpm-web-app/components/pages';

export default Search;
